<template>
    <div :class="getCSSClass('repository-manager-function-popup-row')">
        <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Célmappa')"></label></div>
        <div :class="getCSSClass('repository-manager-function-popup-column')">

        </div>

    </div>

</template>

<script>
    export default {
        props: {
            operationsUrl: {type: String},
        },
        data: function () {
            return {}
        },
        mounted() {
        },
        methods: {},
        computed: {},
        watch: {}

    }
</script>
